import { useEffect, useState } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type TargetFeatureName = {
  featureIndex: number;
  childIndex: number;
} | null;

type UseFeatureLayer = () => TargetFeatureName;

/**
 * # Open a Feature Layer
 */
export const useFeatureLayer: UseFeatureLayer = () => {
  const [selectedFeatureLayer, setSelectedFeatureLayer] =
    useState<TargetFeatureName>(null);

  // This listener is for when krpano requests for a Feature to be opened
  useEffect(() => {
    const readFeatureLayerHandler = (
      event: WindowEventMap["krpano__feature_read"]
    ) => {
      // NOTE: Only check for `undefined`, we expect `null` when closing the
      // Feature Layer
      if (
        notNullNorUndefined(event.detail) &&
        event.detail.featureIndex !== undefined &&
        event.detail.childIndex !== undefined
      ) {
        if (
          notNullNorUndefined(event.detail.featureIndex) &&
          notNullNorUndefined(event.detail.childIndex)
        ) {
          setSelectedFeatureLayer({
            featureIndex: event.detail.featureIndex,
            childIndex: event.detail.childIndex,
          });
        } else {
          setSelectedFeatureLayer(null);
        }
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__feature_read", readFeatureLayerHandler);
    return () => {
      window.removeEventListener(
        "krpano__feature_read",
        readFeatureLayerHandler
      );
    };
  }, []);

  return selectedFeatureLayer;
};
